export default "<bt-alcohol></bt-alcohol>\n"